import React from 'react';
import { connect } from 'react-redux';
import ParentAccountSearch from '../components/forms/ParentAccountSearch';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AlertWarning from 'material-ui/svg-icons/alert/warning';
import {
  mergeRequestDialog,
  mergeCancelDialog,
  mergeCollective,
  setMergeInto,
} from '../actions';

function dialogActions(props) {
  return [
    <FlatButton
      label="Cancel"
      secondary={true}
      onClick={props.onMergeCancel}
    />,
    <FlatButton
      label="Proceed"
      primary={true}
      keyboardFocused={true}
      onClick={props.onMergeProceed.bind(this, props.mergeId, props.mergeIntoId)}
    />,
  ];
}

function MergeDialog(props) {
  return (
    <Dialog
      title="Merge Accounts"
      actions={dialogActions(props)}
      modal={false}
      open={props.mergeDialog}
      onRequestClose={props.onMergeCancel}
    >
      {props.mergeDialog &&
        <div>
          <h3>Merge <i>{props.name}</i> into...</h3>
          <p style={{
            padding: 10,
            backgroundColor: 'seashell',
            fontSize: '0.9em',
          }}>
            <AlertWarning style={{ width: '1.2em', verticalAlign: 'middle' }} />
            &nbsp;Warning: This action deletes this Collective and assigns all Influencers to the new selected Collective.
            No Collective metadata (like address) is saved to the selected merge Collective.
          </p>
          <ParentAccountSearch
            fullWidth={true}
            updateForm={props.onGetNewCollective}
          />
        </div>
      }
    </Dialog>
  );
}

function mapStateToProps(state) {
  return {
    mergeDialog: state.get('importer').get('mergeId') !== 0,
    mergeId: state.get('importer').get('mergeId'),
    mergeIntoId: state.get('importer').get('mergeIntoId'),
    isFetching: state.get('collectives').get('isFetching') && state.get('importer').get('isFetching'),
  };
}

function mapDispatchToProps(dispatch) {
  return {

    onMergeCancel: function () {
      dispatch(mergeCancelDialog());
    },

    onMergeProceed: function (oldCollectiveId, newCollectiveId) {
      dispatch(mergeCollective(oldCollectiveId, newCollectiveId));
      dispatch(mergeCancelDialog());
    },

    onGetNewCollective: function (newCollectiveId) {
      dispatch(setMergeInto(newCollectiveId));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MergeDialog);



/** WEBPACK FOOTER **
 ** ./components/MergeDialog.js
 **/